export default "__VITE_ASSET__k1OiB$4d__"